export type PaletteColor =
  | "indigo-400"
  | "neo-green-400"
  | "yellow-400"
  | "light-blue-400"
  | "pink-400"
  | "green-400"
  | "orange-400"
  | "blue-400"
  | "rose-400"
  | "violet-400"
  | "teal-400"
  | "light-blue-600"
  | "orange-600"
  | "cyan-400"
  | "green-500"
  | "yellow-600"
  | "indigo-600"
  | "pink-600"
  | "violet-600"
  | "cyan-600";

export type IndicatorColor =
  | "green-500"
  | "yellow-500"
  | "indigo-400"
  | "gray-400";

export type AdditionalColor =
  | "red-700"
  | "red-500"
  | "red-200"
  | "yellow-400"
  | "orange-500"
  | "gray-200"
  | "gray-600"
  | "indigo-500";

export type ColorIconColor = PaletteColor | IndicatorColor | AdditionalColor;

/**
 * HEX colors inlined here because we do not use
 * them as theme colors from the design system.
 *
 * These colors used specifically for indicators and chart legends
 * as special palette colors.
 */
const PALETTE_HEX: Record<PaletteColor, string> = {
  "indigo-400": "#8085FF",
  "neo-green-400": "#9ED334",
  "yellow-400": "#FBBF24",
  "light-blue-400": "#38BDF8",
  "pink-400": "#F472B6",
  "green-400": "#34D399",
  "orange-400": "#FB923C",
  "blue-400": "#60A5FA",
  "rose-400": "#FB7185",
  "violet-400": "#A78BFA",
  "teal-400": "#2DD4BF",
  "light-blue-600": "#0284C7",
  "orange-600": "#EA580C",
  "cyan-400": "#22D3EE",
  "green-500": "#10B981",
  "yellow-600": "#D97706",
  "indigo-600": "#5946E5",
  "pink-600": "#DB2777",
  "violet-600": "#7C3AED",
  "cyan-600": "#0891B2",
} as const;

const INDICATOR_HEX: Record<IndicatorColor, string> = {
  "green-500": "#10B981",
  "yellow-500": "#F59E0B",
  "indigo-400": "#8085FF",
  "gray-400": "#9C9FAF",
} as const;

const ADDITIONAL_HEX: Record<AdditionalColor, string> = {
  "red-700": "#B91C1C",
  "red-500": "#EF4444",
  "red-200": "#FECACA",
  "orange-500": "#F97316",
  "gray-200": "#E5E6EB",
  "gray-600": "#4B5163",
  "indigo-500": "#6A63F1",
  "yellow-400": "#FBBF24",
} as const;

export const COLOR_HEX: Record<ColorIconColor, string> = {
  ...PALETTE_HEX,
  ...INDICATOR_HEX,
  ...ADDITIONAL_HEX,
} as const;

export const PALETTE = Object.values(PALETTE_HEX);
